import * as STD from '@emersya/mpa-std';
import EngineModule from '@emersya/mpa-engine/src/app/client/EngineModule';
import { NS as PlannerFurnitureEditorNS } from '../components/PlannerFurnitureEditor/Editor/PlannerFurnitureEditor';

export default () => new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth: false,
	id: 'totalExpo-viewer-planner-screen-editor',
	dependencies: [
		'viewer-planner',
		'oms-basket'
	],
	allowedCustomers: null,
	modulesBefore: ['totalExpo-viewer-planner-floor-editor'],
	modulesAfter: [],
	usableCondition: null,
	displayCondition: null,
	generateComponentConfiguration(): PlannerFurnitureEditorNS.Configuration {
		const typeFilter = this.configuration.typeFilter;
		if (!typeFilter)
			throw STD.errors.user(`Missing typeFilter for module ${this.id}`, {});

		return {
			searchBar: false,
			countFurniture: true,
			typeFilter
		};
	}
});
